import { IconClock16, Label, Tooltip } from '@cian/ui-kit';
import * as React from 'react';
import { useMemo } from 'react';

import * as styles from './styles.css';
import { TCardShieldsProps } from './types';
import { useApplicationContext } from '../../utils/applicationContext';
import { FromCommercialOwnerShield } from '../FromCommercialOwnerShield';
import { ImageShield } from '../ImageShield';

export const CardShields: React.FC<TCardShieldsProps> = props => {
  const { agentLists, isCommericalOwner, isEarlyAccessEnabled, isMobile } = props;
  const { config } = useApplicationContext();

  const textsMap = config.get<Record<string, string>>('sellingTypes.agentLists');
  const isEarlyAccessFavoritesEnabled = !!config.get<boolean>('EarlyAccessFavorites.Enabled');

  const texts = useMemo(() => {
    if (!textsMap || !agentLists) {
      return [];
    }

    return agentLists.map(agentList => textsMap?.[agentList]).filter(Boolean) as string[];
  }, [agentLists, textsMap]);

  return (
    <>
      {isCommericalOwner && <FromCommercialOwnerShield isMobile={!!isMobile} className={styles['shield']} />}
      {isEarlyAccessEnabled && isEarlyAccessFavoritesEnabled && (
        <Tooltip
          theme="white"
          placement="bottom"
          title="Недавно опубликованные объявления от собственников, просмотр контактов первые несколько часов — платный"
        >
          <Label
            color="decorative-purple"
            background="decorative-lavender-transparent"
            icon={<IconClock16 color="decorative-purple" />}
            data-testid="early-access-label"
            className={styles['shield']}
          >
            Ранний доступ
          </Label>
        </Tooltip>
      )}
      {texts.map((text, index) => (
        <ImageShield bgc="gray" title={text} color="theme-dark" key={index} className={styles['shield']} />
      ))}
    </>
  );
};

CardShields.displayName = 'CardShields';
